import React, { useState, useEffect } from "react";
import Navbar from "./navbar";
import { FaMicrophone } from "react-icons/fa"; // Importing microphone icon
import { FaClock, FaCheckCircle } from "react-icons/fa"; // Importing match status icons
import BottomBar from "./BottomBar";
import "./Dashboard.css";
import SliderComponent from "./SliderComponent";
import { useNavigate } from 'react-router-dom';
import { FaWhatsapp } from "react-icons/fa"; // Add this import

// import MatchList from './MatchList';
// import { color } from "framer-motion";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();


  
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    
  }, []);

  return (
    <div>
      <Navbar />
      <BottomBar />

      <div className="dashboard-container">
        {loading ? (
          
          <div className="skeleton-container">
            <div className="skeleton-box"></div>
            <div className="skeleton-box"></div>
            <div className="skeleton-box"></div>
          </div>
          
        ) : (
          
          <>
          <SliderComponent/>
            <button className="updates-button" onClick={() => window.location.href='/updates'}>
          <FaMicrophone className="icon" /> Important Updates
        </button>
       
            {/* My Matches Section */}
            <div className="matches-container">
            <div className="match-box" onClick={() => navigate('/joined-matches')}>
  <FaClock className="match-icon ongoing" />
  <h3>Join One</h3>
</div>


          
          <div className="match-box" onClick={() => navigate('/completematchpage')}>
            <FaCheckCircle className="match-icon completed" />
            <h3>Completed</h3>
          </div>
            </div>

            {/* Esports Games Section */}
            
            <h2 className="section-title">Esports Games</h2>
<div className="games-container">
  <div className="game-box" onClick={() => navigate('/tags/1v1')}>
    <img src="./images/1v1.jpg" alt="Game 1" />
    <h4>1V1</h4>
  </div>
  <div className="game-box" onClick={() => navigate('/tags/BR%20Survival')}>
    <img src="./images/sur.webp" alt="Game 2" />
    <h4>BR Survival</h4>
  </div>
  <div className="game-box" onClick={() => navigate('/tags/BR%20Perkill')}>
    <img src="./images/kill.jpg" alt="Game 3" />
    <h4>BR Perkill</h4>
  </div>
</div>

          </>
        )}
      </div>
      {!loading && (
        
  <a
    href="https://whatsapp.com/channel/0029Vb5yksE11ulTUSnpYO1m" // 🔁 Replace with your actual link
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float"
    title="Join our WhatsApp Group"
  >
    <FaWhatsapp />
  </a>
)}


    </div>
    
    
  );
  
};

export default Dashboard;







